import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-types-papi';

export type UpdateCoverDeviationPayload = {
  deviation: PapiDeviation;
  version?: number;
};
export const updateCoverDeviation = createAction(
  'UPDATE_COVER_DEVIATION',
  (payload: UpdateCoverDeviationPayload) => payload
);

export type UpdateCoverDeviationOffsetYPayload = {
  offsetY: number;
  version: number;
};
export const updateCoverDeviationOffsetY = createAction(
  'UPDATE_COVER_DEVIATION_OFFSET_Y',
  (payload: UpdateCoverDeviationOffsetYPayload) => payload
);

export const deleteCoverDeviation = createAction(
  'DELETE_COVER_DEVIATION',
  () => ({})
);
